import type { ComponentType } from 'react'

import { useMatches } from '@tanstack/react-router'

import { Screen } from '@/shared/ui/Layout'
import { PageListScreenSkeleton } from '@/shared/ui/Skeleton'

/**
 * O que ocupa a área de conteúdo enquanto o evento carrega.
 *
 * A rota declara o próprio esqueleto em `staticData.bootSkeleton`, ao lado do
 * componente que ele representa. Um registro central rota→skeleton funcionaria
 * hoje e falharia em silêncio na primeira rota que alguém esquecesse de
 * registrar; declarado na rota, rota nova nasce coberta — pelo default, se não
 * declarar nada.
 *
 * Por que não o `pendingComponent` do próprio router: ele dispara enquanto o
 * LOADER da rota está pendente, e a espera aqui é outra — a query do evento no
 * `Guard`, acima da rota. `staticData` é o que permite a rota declarar sua
 * intenção para um mecanismo que não é o do router.
 */

export type BootSkeletonComponent = ComponentType

type RotaComSkeleton = { staticData?: { bootSkeleton?: BootSkeletonComponent } }

export const BootSkeleton = () => {
  const matches = useMatches()

  // Da folha para a raiz: a rota mais específica ganha, que é a que o
  // participante está abrindo.
  const declarado = [...matches]
    .reverse()
    .map(match => (match as unknown as RotaComSkeleton).staticData?.bootSkeleton)
    .find(Boolean)

  if (declarado) {
    const Declarado = declarado
    return <Declarado />
  }

  // Default: a forma mais comum do produto é lista de recursos. Genérico o
  // bastante para não mentir sobre o conteúdo, específico o bastante para não
  // ser uma tela vazia.
  return (
    <Screen>
      <Screen.Content className="pt-2">
        <PageListScreenSkeleton />
      </Screen.Content>
    </Screen>
  )
}
